// src/pages/mantenimiento/TabTickets.jsx
// F-MTO-03 completo: abrir ticket + cierre con las 4 secciones del PDF.
import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import styles from './estilos';
import { Campo } from './componentes';

function TabTickets() {
  const [equipos, setEquipos] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mensaje, setMensaje] = useState(null);
  const [guardando, setGuardando] = useState(false);

  const DEPARTAMENTOS = ['Producción', 'Calidad', 'Mantenimiento', 'Almacén y Logística', 'Recursos Humanos', 'I&D', 'Administración y Finanzas', 'Otro'];

  const [form, setForm] = useState({
    equipo_id: '', linea: '', tipo_mantenimiento: 'Correctivo',
    descripcion_falla: '', hora_reporte: new Date().toISOString().slice(0, 16),
    folio_ticket_lista: '', departamento: 'Mantenimiento',
  });

  const [soloAbiertos, setSoloAbiertos] = useState(true);
  const [sincronizando, setSincronizando] = useState(false);
  const [mensajeSync, setMensajeSync] = useState(null);

  async function handleSincronizar() {
    try {
      setSincronizando(true);
      setMensajeSync(null);
      const res = await api.post('/api/mantenimiento/sync/tickets-lista');
      const { creados, caidos_al_generico, total_pendientes_en_lista } = res.data.data;
      setMensajeSync({
        tipo: caidos_al_generico > 0 ? 'aviso' : 'ok',
        texto: `${creados} ticket(s) nuevo(s) importado(s) de ${total_pendientes_en_lista} pendientes en la lista.` +
          (caidos_al_generico > 0 ? ` ${caidos_al_generico} sin equipo específico — cayeron en "Instalaciones / Obra General"; revísalos y reasígnalos al cerrarlos si aplica.` : ''),
      });
      cargar();
    } catch (err) {
      console.error(err);
      setMensajeSync({ tipo: 'error', texto: err.response?.data?.error || 'No se pudo sincronizar.' });
    } finally {
      setSincronizando(false);
    }
  }
  const [cierreAbierto, setCierreAbierto] = useState(null); // id del ticket en proceso de cierre
  const [cierreForm, setCierreForm] = useState({});
  const [guardandoCierre, setGuardandoCierre] = useState(false);

  const cierreVacio = (equipoActualId, departamentoActual) => ({
    equipo_id: equipoActualId,
    departamento: departamentoActual || '',
    hora_cierre: new Date().toISOString().slice(0, 16),
    uso_refaccion: false, zona_trabajo: '',
    tuvo_reparacion_temporal: false, descripcion_reparacion_temporal: '',
    temporal_nombre_quien_realiza: '', temporal_empresa: '', temporal_fecha: '', temporal_fecha_compromiso: '', temporal_nombre_quien_autoriza: '',
    descripcion_reparacion_final: '', final_nombre_quien_realiza: '', final_empresa: '', final_fecha: '',
    equipo_funciona_normal: true, nombre_quien_recibe: '',
    cal_equipo_herramientas: false, cal_equipo_trapo_sucio: false, cal_equipo_rebabas: false, cal_equipo_manchas_quimico: false, cal_equipo_producto_contaminado: false, cal_folio_ppni: '',
    cal_area_quimicos: false, cal_area_herramientas: false, cal_area_manchas_quimicos: false, cal_area_basura: false, cal_area_rebabas: false, cal_area_otros: '',
    nombre_quien_libera_calidad: '', observaciones: '',
    respuestas: {}, // { [punto_id]: true/false } — solo si el equipo tiene checklist
  });

  const [detalleAbierto, setDetalleAbierto] = useState(null);
  const [detallePuntos, setDetallePuntos] = useState([]);
  async function verDetalleChecklist(ticketId) {
    if (detalleAbierto === ticketId) { setDetalleAbierto(null); return; }
    const res = await api.get(`/api/mantenimiento/tickets/${ticketId}/checklist-detalle`);
    setDetallePuntos(res.data.data);
    setDetalleAbierto(ticketId);
  }

  function abrirPanelCierre(id) {
    setCierreAbierto(cierreAbierto === id ? null : id);
    if (!cierreForm[id]) {
      const ticket = tickets.find((t) => t.id === id);
      setCierreForm((prev) => ({ ...prev, [id]: cierreVacio(ticket?.equipo_id, ticket?.departamento) }));
    }
  }
  function setCierre(id, campo, valor) {
    setCierreForm((prev) => ({ ...prev, [id]: { ...prev[id], [campo]: valor } }));
  }

  async function cargar() {
    try {
      setCargando(true);
      const [resEq, resTk] = await Promise.all([
        api.get('/api/mantenimiento/equipos', { params: { activo: 'true' } }),
        api.get('/api/mantenimiento/tickets', { params: soloAbiertos ? { abiertos: 'true' } : {} }),
      ]);
      setEquipos(resEq.data.data);
      setTickets(resTk.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, [soloAbiertos]); // eslint-disable-line react-hooks/exhaustive-deps

  function set(campo, valor) { setForm((prev) => ({ ...prev, [campo]: valor })); }

  async function handleAbrirTicket() {
    if (!form.equipo_id) { setMensaje({ tipo: 'error', texto: 'Selecciona un equipo.' }); return; }
    try {
      setGuardando(true);
      setMensaje(null);
      await api.post('/api/mantenimiento/tickets', form);
      setMensaje({ tipo: 'ok', texto: '✓ Ticket abierto.' });
      setForm({ equipo_id: '', linea: '', tipo_mantenimiento: 'Correctivo', descripcion_falla: '', hora_reporte: new Date().toISOString().slice(0, 16), folio_ticket_lista: '', departamento: 'Mantenimiento' });
      cargar();
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo abrir el ticket.' });
    } finally {
      setGuardando(false);
    }
  }

  async function handleCerrarTicket(id, equipoPuntos) {
    const datos = cierreForm[id] || cierreVacio();
    const respuestas_checklist = (equipoPuntos || []).map((p) => ({ punto_id: p.id, cumple: datos.respuestas[p.id] !== false }));
    try {
      setGuardandoCierre(true);
      await api.put(`/api/mantenimiento/tickets/${id}/cerrar`, { ...datos, respuestas_checklist });
      setCierreAbierto(null);
      cargar();
    } catch (err) {
      console.error(err);
      alert('No se pudo cerrar el ticket.');
    } finally {
      setGuardandoCierre(false);
    }
  }

  return (
    <div>
      <div style={styles.tarjeta}>
        <div style={styles.seccionTitulo}>Abrir Ticket de Mantenimiento</div>
        <div style={styles.grid3}>
          <Campo label="Equipo">
            <select value={form.equipo_id} onChange={(e) => set('equipo_id', e.target.value)} style={styles.input}>
              <option value="">Selecciona...</option>
              {equipos.map((e) => <option key={e.id} value={e.id}>{e.codigo ? `${e.codigo} — ` : ''}{e.descripcion} ({e.area})</option>)}
            </select>
          </Campo>
          <Campo label="Tipo">
            <select value={form.tipo_mantenimiento} onChange={(e) => set('tipo_mantenimiento', e.target.value)} style={styles.input}>
              <option value="Correctivo">Correctivo (falla)</option>
              <option value="Preventivo">Preventivo</option>
            </select>
          </Campo>
          <Campo label="Línea (opcional)">
            <input type="text" value={form.linea} onChange={(e) => set('linea', e.target.value)} placeholder="Ej. Granola, Barras" style={styles.input} />
          </Campo>
          <Campo label="Departamento (para el costo del 3.6)">
            <select value={form.departamento} onChange={(e) => set('departamento', e.target.value)} style={styles.input}>
              {DEPARTAMENTOS.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </Campo>
        </div>
        <Campo label="Hora de reporte (inicio de la falla)">
          <input type="datetime-local" value={form.hora_reporte} onChange={(e) => set('hora_reporte', e.target.value)} style={styles.input} />
        </Campo>
        <Campo label="Descripción de la falla">
          <input type="text" value={form.descripcion_falla} onChange={(e) => set('descripcion_falla', e.target.value)} style={{ ...styles.input, width: '100%' }} />
        </Campo>
        <Campo label="Folio de Ticket (de la Lista de Microsoft, si aplica)">
          <input type="text" value={form.folio_ticket_lista} onChange={(e) => set('folio_ticket_lista', e.target.value)} placeholder="Ej. 53 (el ID de la lista BD_HelpDesk)" style={{ ...styles.input, width: '100%' }} />
        </Campo>
        {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}
        <button onClick={handleAbrirTicket} disabled={guardando} style={styles.botonGuardar}>
          {guardando ? 'Guardando...' : 'Abrir Ticket'}
        </button>
      </div>

      <div style={{ ...styles.headerFila, marginTop: '20px', flexWrap: 'wrap', gap: 10 }}>
        <h2 style={styles.subtituloLista}>Tickets</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
          <label style={{ fontSize: '12px', color: '#6E4F80', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <input type="checkbox" checked={soloAbiertos} onChange={(e) => setSoloAbiertos(e.target.checked)} />
            Solo abiertos
          </label>
          <button onClick={handleSincronizar} disabled={sincronizando} style={styles.botonBuscar2}>
            {sincronizando ? 'Sincronizando...' : '↻ Traer de la Lista de Microsoft'}
          </button>
        </div>
      </div>
      {mensajeSync && <div style={{ ...styles.mensaje, color: mensajeSync.tipo === 'error' ? '#B23A48' : mensajeSync.tipo === 'aviso' ? '#C08A2B' : '#3E7C5A' }}>{mensajeSync.texto}</div>}

      {cargando ? <div>Cargando...</div> : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Folio</th><th style={styles.th}>Equipo</th><th style={styles.th}>Tipo</th><th style={styles.th}>Reportado</th>
                <th style={styles.th}>Falla</th><th style={styles.th}>Estado / Cierre</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((t) => {
                const c = cierreForm[t.id] || cierreVacio();
                return (
                  <React.Fragment key={t.id}>
                    <tr>
                      <td style={styles.td}>{t.folio_ticket_lista || '—'}</td>
                      <td style={styles.td}>
                        {t.equipo_codigo ? `${t.equipo_codigo} — ` : ''}{t.equipo_descripcion}
                        {t.equipo_descripcion === 'Instalaciones / Obra General' && !t.hora_cierre && (
                          <span style={{ display: 'block', fontSize: 10, color: '#C08A2B' }}>⚠ revisar equipo al cerrar</span>
                        )}
                      </td>
                      <td style={styles.td}>{t.tipo_mantenimiento}</td>
                      <td style={styles.td}>{new Date(t.hora_reporte).toLocaleString('es-MX')}</td>
                      <td style={{ ...styles.td, maxWidth: 200, whiteSpace: 'normal' }}>{t.descripcion_falla || '—'}</td>
                      <td style={styles.td}>
                        {t.hora_cierre ? (
                          <div>
                            <span style={{ color: '#3E7C5A', fontWeight: 600 }}>✓ Cerrado ({parseFloat(t.horas_reparacion).toFixed(1)} hrs)</span>
                            {parseInt(t.total_respuestas_checklist) > 0 && (
                              <div style={{ marginTop: 4 }}>
                                {parseInt(t.respuestas_no_cumple) > 0
                                  ? <span style={{ color: '#B23A48', fontSize: 11 }}>⚠ {t.respuestas_no_cumple} de {t.total_respuestas_checklist} no cumple</span>
                                  : <span style={{ color: '#3E7C5A', fontSize: 11 }}>✓ Checklist OK</span>}
                                {' '}
                                <button onClick={() => verDetalleChecklist(t.id)} style={styles.linkChico}>{detalleAbierto === t.id ? 'Ocultar' : 'Ver'}</button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <button onClick={() => abrirPanelCierre(t.id)} style={styles.botonCerrar}>
                            {cierreAbierto === t.id ? 'Ocultar' : 'Cerrar Ticket'}
                          </button>
                        )}
                      </td>
                    </tr>
                    {detalleAbierto === t.id && (
                      <tr>
                        <td colSpan={6} style={{ background: '#FAF6F0', padding: 12 }}>
                          {detallePuntos.map((p, i) => (
                            <div key={i} style={{ fontSize: 12, padding: '3px 0', color: p.cumple ? '#3A2E42' : '#B23A48' }}>
                              {p.cumple ? '✓' : '✕'} {p.orden}. {p.descripcion}
                            </div>
                          ))}
                        </td>
                      </tr>
                    )}
                    {cierreAbierto === t.id && (() => {
                      const equipoDelTicket = equipos.find((eq) => eq.id === c.equipo_id);
                      const puntosDelEquipo = equipoDelTicket?.puntos || [];
                      const esGenerico = equipoDelTicket?.descripcion === 'Instalaciones / Obra General';
                      return (
                      <tr>
                        <td colSpan={6} style={{ background: '#FAF6F0', padding: 16 }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: '#6E4F80', textTransform: 'uppercase', marginBottom: 10 }}>Cierre — F-MTO-03</div>

                          <div className="fila2">
                            <Campo label="Equipo (revisa y corrige si no es el correcto)">
                              <select value={c.equipo_id || ''} onChange={(e) => setCierre(t.id, 'equipo_id', Number(e.target.value))} style={styles.input}>
                                {equipos.map((eq) => <option key={eq.id} value={eq.id}>{eq.codigo ? `${eq.codigo} — ` : ''}{eq.descripcion}</option>)}
                              </select>
                            </Campo>
                            <Campo label="Departamento (para el costo del 3.6)">
                              <select value={c.departamento} onChange={(e) => setCierre(t.id, 'departamento', e.target.value)} style={styles.input}>
                                <option value="">Selecciona...</option>
                                {DEPARTAMENTOS.map((d) => <option key={d} value={d}>{d}</option>)}
                              </select>
                            </Campo>
                          </div>
                          {esGenerico && (
                            <div style={styles.avisoAdvertencia}>
                              Este ticket cayó en "Instalaciones / Obra General" (no se encontró el equipo exacto en la Lista). Si en realidad es sobre maquinaria específica, cámbialo arriba antes de cerrar — así sí cuenta para su indicador.
                            </div>
                          )}
                          {!c.departamento && (
                            <div style={styles.avisoAdvertencia}>
                              Este ticket no tiene Departamento (se importó antes de que agregáramos ese campo) — selecciónalo arriba para que cuente en el 3.6.
                            </div>
                          )}

                          <div style={styles.grid3}>
                            <Campo label="Zona de trabajo">
                              <select value={c.zona_trabajo} onChange={(e) => setCierre(t.id, 'zona_trabajo', e.target.value)} style={styles.input}>
                                <option value="">Selecciona...</option>
                                <option value="Zona 1">Zona 1</option>
                                <option value="Zona 2">Zona 2</option>
                                <option value="Zona 3">Zona 3</option>
                              </select>
                            </Campo>
                            <Campo label="Hora de cierre (equipo vuelve a operar)">
                              <input type="datetime-local" value={c.hora_cierre} onChange={(e) => setCierre(t.id, 'hora_cierre', e.target.value)} style={styles.input} />
                            </Campo>
                            <Campo label="¿Se utilizó refacción?">
                              <label style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 0', fontSize: 13 }}>
                                <input type="checkbox" checked={c.uso_refaccion} onChange={(e) => setCierre(t.id, 'uso_refaccion', e.target.checked)} />
                                Sí — pasa a la pestaña "Costos" para capturar qué se usó y cuánto costó
                              </label>
                            </Campo>
                          </div>

                          {puntosDelEquipo.length > 0 && (
                            <div style={{ marginTop: 14 }}>
                              <div style={{ fontSize: 11, fontWeight: 700, color: '#6E4F80', textTransform: 'uppercase', marginBottom: 8 }}>
                                Checklist de Inspección (F-MTO-08) — este equipo tiene checklist propio
                              </div>
                              {puntosDelEquipo.map((p) => (
                                <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderBottom: '1px solid #F0E9E0', fontSize: 12.5 }}>
                                  <span style={{ flex: 3 }}>{p.orden}. {p.descripcion}</span>
                                  <div style={{ flex: 1, display: 'flex', gap: 10, justifyContent: 'center' }}>
                                    <label style={{ fontSize: 12 }}>
                                      <input type="radio" name={`ck-${t.id}-${p.id}`} checked={c.respuestas[p.id] !== false} onChange={() => setCierre(t.id, 'respuestas', { ...c.respuestas, [p.id]: true })} /> Cumple
                                    </label>
                                    <label style={{ fontSize: 12 }}>
                                      <input type="radio" name={`ck-${t.id}-${p.id}`} checked={c.respuestas[p.id] === false} onChange={() => setCierre(t.id, 'respuestas', { ...c.respuestas, [p.id]: false })} /> No cumple
                                    </label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                          <div style={{ marginTop: 10 }}>
                            <label style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <input type="checkbox" checked={c.tuvo_reparacion_temporal} onChange={(e) => setCierre(t.id, 'tuvo_reparacion_temporal', e.target.checked)} />
                              ¿Hubo reparación temporal?
                            </label>
                          </div>

                          {c.tuvo_reparacion_temporal && (
                            <div style={{ marginTop: 8, paddingLeft: 14, borderLeft: '3px solid #E6DDD2' }}>
                              <Campo label="Describir reparación temporal">
                                <input type="text" value={c.descripcion_reparacion_temporal} onChange={(e) => setCierre(t.id, 'descripcion_reparacion_temporal', e.target.value)} style={{ ...styles.input, width: '100%' }} />
                              </Campo>
                              <div style={styles.grid3}>
                                <Campo label="Quién realiza"><input type="text" value={c.temporal_nombre_quien_realiza} onChange={(e) => setCierre(t.id, 'temporal_nombre_quien_realiza', e.target.value)} style={styles.input} /></Campo>
                                <Campo label="Empresa"><input type="text" value={c.temporal_empresa} onChange={(e) => setCierre(t.id, 'temporal_empresa', e.target.value)} style={styles.input} /></Campo>
                                <Campo label="Fecha reparación temporal"><input type="date" value={c.temporal_fecha} onChange={(e) => setCierre(t.id, 'temporal_fecha', e.target.value)} style={styles.input} /></Campo>
                              </div>
                              <div style={styles.grid3}>
                                <Campo label="Fecha compromiso de reemplazo"><input type="date" value={c.temporal_fecha_compromiso} onChange={(e) => setCierre(t.id, 'temporal_fecha_compromiso', e.target.value)} style={styles.input} /></Campo>
                                <Campo label="Quién autoriza"><input type="text" value={c.temporal_nombre_quien_autoriza} onChange={(e) => setCierre(t.id, 'temporal_nombre_quien_autoriza', e.target.value)} style={styles.input} /></Campo>
                              </div>
                            </div>
                          )}

                          <div style={{ fontSize: 11, fontWeight: 700, color: '#6E4F80', textTransform: 'uppercase', margin: '14px 0 8px' }}>Reparación Final</div>
                          <Campo label="Describir reparación final">
                            <input type="text" value={c.descripcion_reparacion_final} onChange={(e) => setCierre(t.id, 'descripcion_reparacion_final', e.target.value)} style={{ ...styles.input, width: '100%' }} />
                          </Campo>
                          <div style={styles.grid3}>
                            <Campo label="Quién realiza"><input type="text" value={c.final_nombre_quien_realiza} onChange={(e) => setCierre(t.id, 'final_nombre_quien_realiza', e.target.value)} style={styles.input} /></Campo>
                            <Campo label="Empresa"><input type="text" value={c.final_empresa} onChange={(e) => setCierre(t.id, 'final_empresa', e.target.value)} style={styles.input} /></Campo>
                            <Campo label="Fecha de reparación final"><input type="date" value={c.final_fecha} onChange={(e) => setCierre(t.id, 'final_fecha', e.target.value)} style={styles.input} /></Campo>
                          </div>

                          <div style={{ fontSize: 11, fontWeight: 700, color: '#6E4F80', textTransform: 'uppercase', margin: '14px 0 8px' }}>Liberación del Mantenimiento</div>
                          <div style={styles.grid3}>
                            <Campo label="¿El equipo se reparó y funciona normalmente?">
                              <select value={c.equipo_funciona_normal ? 'si' : 'no'} onChange={(e) => setCierre(t.id, 'equipo_funciona_normal', e.target.value === 'si')} style={styles.input}>
                                <option value="si">Sí</option><option value="no">No</option>
                              </select>
                            </Campo>
                            <Campo label="Firma de recibido (quien emite el ticket)"><input type="text" value={c.nombre_quien_recibe} onChange={(e) => setCierre(t.id, 'nombre_quien_recibe', e.target.value)} style={styles.input} /></Campo>
                          </div>

                          <div style={{ fontSize: 11, fontWeight: 700, color: '#6E4F80', textTransform: 'uppercase', margin: '14px 0 8px' }}>Liberación por Calidad</div>
                          <div className="fila2">
                            <div>
                              <div style={{ fontSize: 11, color: '#8A7690', marginBottom: 6 }}>El equipo se encuentra libre de:</div>
                              {[['cal_equipo_herramientas', 'Herramientas o piezas'], ['cal_equipo_trapo_sucio', 'Trapo sucio'], ['cal_equipo_rebabas', 'Rebabas metálicas'], ['cal_equipo_manchas_quimico', 'Manchas o derrames de químico'], ['cal_equipo_producto_contaminado', 'Producto contaminado']].map(([campo, label]) => (
                                <label key={campo} style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                                  <input type="checkbox" checked={c[campo]} onChange={(e) => setCierre(t.id, campo, e.target.checked)} /> {label}
                                </label>
                              ))}
                              <Campo label="Folio PPNI"><input type="text" value={c.cal_folio_ppni} onChange={(e) => setCierre(t.id, 'cal_folio_ppni', e.target.value)} style={styles.input} /></Campo>
                            </div>
                            <div>
                              <div style={{ fontSize: 11, color: '#8A7690', marginBottom: 6 }}>El área se encuentra libre de:</div>
                              {[['cal_area_quimicos', 'Químicos'], ['cal_area_herramientas', 'Herramientas o piezas'], ['cal_area_manchas_quimicos', 'Manchas o derrames de químicos'], ['cal_area_basura', 'Basura'], ['cal_area_rebabas', 'Rebabas metálicas']].map(([campo, label]) => (
                                <label key={campo} style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                                  <input type="checkbox" checked={c[campo]} onChange={(e) => setCierre(t.id, campo, e.target.checked)} /> {label}
                                </label>
                              ))}
                              <Campo label="Otros"><input type="text" value={c.cal_area_otros} onChange={(e) => setCierre(t.id, 'cal_area_otros', e.target.value)} style={styles.input} /></Campo>
                            </div>
                          </div>
                          <Campo label="Firma de liberación de Calidad"><input type="text" value={c.nombre_quien_libera_calidad} onChange={(e) => setCierre(t.id, 'nombre_quien_libera_calidad', e.target.value)} style={styles.input} /></Campo>
                          <Campo label="Observaciones"><input type="text" value={c.observaciones} onChange={(e) => setCierre(t.id, 'observaciones', e.target.value)} style={{ ...styles.input, width: '100%' }} /></Campo>

                          <button onClick={() => handleCerrarTicket(t.id, puntosDelEquipo)} disabled={guardandoCierre} style={styles.botonGuardar}>
                            {guardandoCierre ? 'Guardando...' : 'Guardar y Cerrar Ticket'}
                          </button>
                        </td>
                      </tr>
                      );
                    })()}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          {tickets.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin tickets.</p>}
        </div>
      )}
    </div>
  );
}


export default TabTickets;